import * as React from "react";
import clsx from "clsx";
import { makeStyles } from "@material-ui/styles";
import Planet from "../Icons/Planet";
const useStyles = makeStyles(({
  palette,
  breakpoints,
  typography
}) => ({
  container: {
    display: "flex",
    alignItems: "center"
  },
  text: {
    [breakpoints.down("sm")]: {
      fontSize: typography.pxToRem(13)
    },
    marginLeft: typography.pxToRem(10),
    color: "#8AC149",
    fontWeight: 700
  },
  icon: {
    [breakpoints.down("sm")]: {
      width: typography.pxToRem(21),
      height: typography.pxToRem(21)
    }
  },
  arrow: {
    width: typography.pxToRem(41),
    height: typography.pxToRem(51),
    fill: "none"
  }
}));

const GreenPlanet = ({
  className,
  iconClassName,
  textClassName
}) => {
  const styles = useStyles();
  return /*#__PURE__*/React.createElement("div", {
    className: clsx(styles.container, className)
  }, /*#__PURE__*/React.createElement(Planet, {
    className: clsx(styles.icon, iconClassName)
  }), /*#__PURE__*/React.createElement("span", {
    className: clsx(styles.text, textClassName)
  }, "This option is the best for our planet"));
};

export default GreenPlanet;